<template>
  <div class="mapouter" v-if="latitude && longitude">
    <div class="gmap_canvas">
      <!-- <iframe
        id="gmap_canvas"
        :src="
          'https://maps.google.com/maps?q=' +
          latitude +
          ',' +
          longitude +
          '&t=&z=13&ie=UTF8&iwloc=&output=embed'
        "
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        :style="{ height: mapHeight }"
      ></iframe> -->
      <a href="https://www.embedgooglemap.net/en/"></a>

     <iframe
        id="gmap_canvas"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        :style="{ height: mapHeight }"
        :src="'https://www.google.com/maps/embed/v1/place?key=AIzaSyCDa-PDir0rUn3UVZHF11rAwrXXC9bV1KQ&q=' + latitude + ',' + longitude">
    </iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "Map",
  props: {
    latitude: Number,
    longitude: Number,
    height: Number,
  },
  data() {
    return { mapHeight: "300px" };
  },
  created() {
    this.mapHeight = this.height ? this.height + "px" : "300px";
  },
};
</script>

<style scoped>
iframe#gmap_canvas {
  width: 100%;
}
</style>
